// src/assets/mockdata/Claims/procedureData.ts
import { ProcedureStatus } from '@dataTypes/claimManagement.types'
import { generateProcedureCode } from '@utils/codeGenerator.util'

const procedureData = [
  {
    procedureName: 'Prophylaxis',
    procedureCode: generateProcedureCode(),
    procedureDate: '2025-01-03',
    provider: 'Dr. John Smith',
    providerFirstName: 'John',
    providerLastName: 'Smith',
    coverage: '100%',
    coverageText: 'Full',
    amount: 1200,
    status: ProcedureStatus.Unclaimed,
  },
  {
    procedureName: 'Root Canal',
    procedureCode: generateProcedureCode(),
    procedureDate: '2025-01-04',
    provider: 'Dr. Jane Doe',
    providerFirstName: 'Jane',
    providerLastName: 'Doe',
    coverage: '80%',
    coverageText: 'Partial',
    amount: 900,
    status: ProcedureStatus.Claimed,
  },
  {
    procedureName: 'Teeth Cleaning',
    procedureCode: generateProcedureCode(),
    procedureDate: '2025-01-07',
    provider: 'Dr. Emily Brown',
    providerFirstName: 'Emily',
    providerLastName: 'Brown',
    coverage: '100%',
    coverageText: 'Full',
    amount: 150,
    status: ProcedureStatus.Claimed,
  },
  {
    procedureName: 'Wisdom Tooth Extraction',
    procedureCode: generateProcedureCode(),
    procedureDate: '2025-01-15',
    provider: 'Dr. Clara Brown',
    providerFirstName: 'Clara',
    providerLastName: 'Brown',
    coverage: '75%',
    coverageText: 'Partial',
    amount: 500,
    status: ProcedureStatus.Claimed,
  },
  {
    procedureName: 'Dental X-Ray',
    procedureCode: generateProcedureCode(),
    procedureDate: '2025-01-20',
    provider: 'Dr. Alex White',
    providerFirstName: 'Alex',
    providerLastName: 'White',
    coverage: '90%',
    coverageText: 'Partial',
    amount: 200,
    status: ProcedureStatus.Claimed,
  },
  {
    procedureName: 'Dental Implant',
    procedureCode: generateProcedureCode(),
    procedureDate: '2025-01-25',
    provider: 'Dr. Robert Green',
    providerFirstName: 'Robert',
    providerLastName: 'Green',
    coverage: '70%',
    coverageText: 'Partial',
    amount: 2500,
    status: ProcedureStatus.Claimed,
  },
  {
    procedureName: 'Tooth Extraction',
    procedureCode: generateProcedureCode(),
    procedureDate: '2025-01-28',
    provider: 'Dr. Lucy Taylor',
    providerFirstName: 'Lucy',
    providerLastName: 'Taylor',
    coverage: '85%',
    coverageText: 'Partial',
    amount: 400,
    status: ProcedureStatus.Claimed,
  },
  {
    procedureName: 'Scaling and Root Planing',
    procedureCode: generateProcedureCode(),
    procedureDate: '2025-02-01',
    provider: 'Dr. William Carter',
    providerFirstName: 'William',
    providerLastName: 'Carter',
    coverage: '80%',
    coverageText: 'Partial',
    amount: 700,
    status: ProcedureStatus.Claimed,
  },
  {
    procedureName: 'Dental Crown',
    procedureCode: generateProcedureCode(),
    procedureDate: '2025-02-05',
    provider: 'Dr. Emma Scott',
    providerFirstName: 'Emma',
    providerLastName: 'Scott',
    coverage: '75%',
    coverageText: 'Partial',
    amount: 1800,
    status: ProcedureStatus.Claimed,
  },
  {
    procedureName: 'Cavity Filling',
    procedureCode: generateProcedureCode(),
    procedureDate: '2025-02-10',
    provider: 'Dr. Sophia Adams',
    providerFirstName: 'Sophia',
    providerLastName: 'Adams',
    coverage: '100%',
    coverageText: 'Full',
    amount: 300,
    status: ProcedureStatus.Claimed,
  },
  {
    procedureName: 'Teeth Whitening',
    procedureCode: generateProcedureCode(),
    procedureDate: '2025-02-15',
    provider: 'Dr. Lucas Martin',
    providerFirstName: 'Lucas',
    providerLastName: 'Martin',
    coverage: '50%',
    coverageText: 'Partial',
    amount: 600,
    status: ProcedureStatus.Claimed,
  },
  {
    procedureName: 'Orthodontic Treatment',
    procedureCode: generateProcedureCode(),
    procedureDate: '2025-02-20',
    provider: 'Dr. Oliver Clark',
    providerFirstName: 'Oliver',
    providerLastName: 'Clark',
    coverage: '65%',
    coverageText: 'Partial',
    amount: 4000,
    status: ProcedureStatus.Claimed,
  },
]

export default procedureData
